export default "__VITE_ASSET__CZYGsFx2__"